import React from "react";

function ElevenLabsBadge() {
  return null;
}

export default ElevenLabsBadge;
